/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { connect } from 'react-redux';
import Dashboard from '../components/dashboard';
import { t } from '../locales/i18n';
import * as R from 'ramda';

function HomePage(props: any) {
  const app = props.app;
  if (app.initializing) {
    return <h2>{t('App is loading ...')}</h2>;
  }
  return (
    <div className="app-container">
      <Dashboard {...props} />
    </div>
  );
}

const findById = (idValue: any) => R.find((item: any) => item._id === idValue);

function decorateQueue(state: any, queue: any) {
  const services = R.filter(R.identity)(
    queue.serviceIds.map((id: any) => findById(id)(state.services.myServices))
  );
  const controlBox =
    findById(queue.controlBoxId)(state.controlBoxes.myControlBoxes) || {};
  const location =
    findById(queue.locationId)(state.locations.myLocations) || {};
  return {
    services,
    location,
    controlBox,
    ...queue
  };
}

function decorateBooth(state: any, booth: any) {
  const controlBox =
    findById(booth.controlBoxId)(state.controlBoxes.myControlBoxes) || {};
  const queues = R.filter(R.identity)(
    booth.queueIds.map((id: any) => findById(id)(state.queues.myQueues))
  );
  return {
    controlBox,
    queues,
    ...booth
  };
}

function decorateDisplay(state: any, display: any) {
  const controlBox =
    findById(display.controlBoxId)(state.controlBoxes.myControlBoxes) || {};
  const queues = R.filter(R.identity)(
    display.queueIds.map((id: any) => findById(id)(state.queues.myQueues))
  );
  const booths = R.filter(R.identity)(
    display.boothIds.map((id: any) => findById(id)(state.booths.myBooths))
  );
  return {
    controlBox,
    queues,
    booths,
    ...display
  };
}

function decorateKiosk(state: any, kiosk: any) {
  const controlBox =
    findById(kiosk.controlBoxId)(state.controlBoxes.myControlBoxes) || {};
  return {
    controlBox,
    ...kiosk
  };
}

function mapStateToProps(state: any) {
  return {
    app: state.app,
    myProfile: state.myProfile,
    services: state.services,
    booths: {
      myBooths: state.booths.myBooths.map((booth: any) =>
        decorateBooth(state, booth)
      )
    },
    displays: {
      myDisplays: state.displays.myDisplays.map((display: any) =>
        decorateDisplay(state, display)
      )
    },
    kiosks: {
      myKiosks: state.kiosks.myKiosks.map((kiosk: any) =>
        decorateKiosk(state, kiosk)
      )
    },
    serviceProviders: state.serviceProviders,
    locations: state.locations,
    controlBoxes: state.controlBoxes,
    queues: {
      myQueues: state.queues.myQueues.map((queue: any) =>
        decorateQueue(state, queue)
      )
    }
  };
}

const ConnectedComponent = connect(mapStateToProps)(HomePage);

export default ConnectedComponent;
